import React, { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

// زر واحد: يولّد وثيقة الهوية (Word قابل للتعديل) وينزّلها مباشرة على الجهاز عبر رابط HTTPS حقيقي (يعمل على iOS/Android/سطح المكتب)
export const BrandDocButton = ({ project, className = "", size = "sm", testId = "brand-doc" }) => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    // iOS/Safari يحجب أي نافذة تُفتح بعد await — نفتحها الآن ضمن ضغطة المستخدم ثم نوجّهها للملف
    const win = window.open("", "_blank");
    try {
      const res = await api.post(`/projects/${project.id}/brand-document/link`);
      const url = res.data.url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${res.data.url}` : res.data.url;
      if (win && !win.closed) win.location.href = url;
      else window.location.assign(url);  // Content-Disposition: attachment → تنزيل مباشر دون مغادرة الصفحة
      toast.success(`جارٍ تنزيل ${res.data.filename}`);
    } catch (err) {
      if (win && !win.closed) win.close();
      toast.error(formatError(err?.response?.data?.detail) || "تعذّر إنشاء الوثيقة — أكمل الاستراتيجية والهوية أولاً");
    } finally { setBusy(false); }
  };

  return (
    <Button size={size} onClick={download} disabled={busy} className={`gap-2 h-auto min-h-9 max-w-full whitespace-normal break-words text-center leading-snug ${className}`} data-testid={`${testId}-btn`}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin shrink-0" /> : <FileText className="w-3.5 h-3.5 shrink-0" />} <span>تنزيل وثيقة الهوية (Word)</span>
    </Button>
  );
};
